import { TypedTranslation } from '../../../../translation/types';

enum PromotionTextKeys {
	COMBO_BUTTON_LABEL = 'SPORTSBOOK_PROMOTION_CAROUSEL_COMBO_BUTTON_LABEL',
	LINK_TITLE = 'SPORTSBOOK_PROMOTION_CAROUSEL_LINK_TITLE',
	LINK_SUB_TITLE = 'SPORTSBOOK_PROMOTION_CAROUSEL_LINK_SUB_TITLE',
	COMBO_MULTI_LEAGUE_LABEL = 'SPORTSBOOK_PROMOTION_CAROUSEL_COMBO_MULTI_LEAGUE_LABEL',
	COMBO_1X2_MARKET_LABEL = 'SPORTSBOOK_PROMOTION_CAROUSEL_COMBO_1X2_MARKET_LABEL',
	COMBO_1X2_MARKET_LABEL_DOUBLE = 'SPORTSBOOK_PROMOTION_CAROUSEL_COMBO_1X2_MARKET_LABEL_DOUBLE',
	IMAGE_ALT = 'SPORTSBOOK_PROMOTION_CAROUSEL_IMAGE_ALT'
}

export type PromotionTranslations = Readonly<TypedTranslation<typeof PromotionTextKeys>>;

export default PromotionTextKeys;
